namespace Portico.Controllers {

	import Inject = Portico.Decorators.Inject;
	import Controller = Portico.Decorators.Controller;

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;
    
    @Controller('app', 'sectionController')
	@Inject('$scope', 'accountService', 'dataService', 'enrollmentService', 'intakeService', 'porticoService', 'prescriberService', 'siteService', 'storageService')
	export class SectionController {
		breadcrumbs: string[]; // ??? move to intake resolve ???
		state: string;

		search: any;
		results: any[];

        constructor(
            private $scope: angular.IScope,
			private accountService: ps.IAccountService,
			private dataService: ps.IDataService,
			private enrollmentService: ps.IEnrollmentService,
			private intakeService: ps.IIntakeService,
			private porticoService: ps.IPorticoService,
			private prescriberService: ps.IPrescriberService,
			private siteService: ps.ISiteService,
			private storageService: ps.IStorageService
        ) {
			const account = this.dataService.session.account; // todo: try to avoid doing this
			const intakeLayout = this.dataService.enterprise.intakeLayout; // todo: try to avoid doing this

			this.breadcrumbs = [];
			this.dataService.session.accountEdit = angular.copy(account); // todo: try to avoid doing this
			this.state = '';

			for (let i = 0; i < intakeLayout.layoutSections.length; i++) {
				const layoutSection = intakeLayout.layoutSections[i];
				const value = this.dataService.getDataValue('Section', 'IsBreadcrumb', layoutSection.name);

				if (value == 'true') {
					this.breadcrumbs.push(layoutSection.name);
				}
			}

			if (this.dataService.state.section === 'start') {
				this.porticoService.section('first', { r2s: this.dataService.state.r2s });
			}
        }

		isActiveBreadcrumb(section: string) {
			return this.dataService.state.section === section;
		}

		isBreadcrumb() {
			const value = this.dataService.getDataValue('Section', 'IsBreadcrumb', this.dataService.state.section);
			return value == 'true';
		}

		isVisitedBreadcrumb(section: string) {
			const intakeLayout = this.dataService.enterprise.intakeLayout;

			for (let i = 0; i < intakeLayout.layoutSections.length; i++) {
				const layoutSection = intakeLayout.layoutSections[i];

				if (layoutSection.name === this.dataService.state.section) {
					return false;
				} else if (layoutSection.name === section) {
					return true;
				}
			}

			return false;
		}
    }
}